import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Elements
import Panel from '../../../../../shared/elements/panel'
class WhiteBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentWillMount () {
  }

  render () {
    let className = ''
    if (this.props.extraClass !== '') className += ' ' + this.props.extraClass
    return (
      <Panel title={this.props.renderTitle ? this.props.titleText : ''} data-col={this.props.datacol}>
        <div className={className}>
          {this.props.renderContent()}
          {this.props.children}
        </div>
      </Panel>
    )
  }
}

WhiteBox.defaultProps = {
  renderTitle: true,
  extraClass: '',
  datacol: '',
  titleIcon: '',
  titleIconAlt: '',
  titleText: '',
  titleTextLeft: '',
  renderContent: () => {
    return null
  }
}

WhiteBox.propTypes = {
  renderTitle: PropTypes.bool,
  extraClass: PropTypes.string,
  datacol: PropTypes.string,
  titleIcon: PropTypes.string,
  titleIconAlt: PropTypes.string,
  titleText: PropTypes.string,
  titleTextLeft: PropTypes.string,
  renderContent: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
}

WhiteBox.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(WhiteBox)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/WhiteBox/index.js